/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnmatchedPlumeOutline } from './UnmatchedPlumeOutline';
import {
    UnmatchedPlumeOutlineFromJSON,
    UnmatchedPlumeOutlineFromJSONTyped,
    UnmatchedPlumeOutlineToJSON,
    UnmatchedPlumeOutlineToJSONTyped,
} from './UnmatchedPlumeOutline';

/**
 * 
 * @export
 * @interface PaginatedUnmatchedPlumeOutlineList
 */
export interface PaginatedUnmatchedPlumeOutlineList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnmatchedPlumeOutlineList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnmatchedPlumeOutlineList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<UnmatchedPlumeOutline>}
     * @memberof PaginatedUnmatchedPlumeOutlineList
     */
    results: Array<UnmatchedPlumeOutline>;
}

/**
 * Check if a given object implements the PaginatedUnmatchedPlumeOutlineList interface.
 */
export function instanceOfPaginatedUnmatchedPlumeOutlineList(value: object): value is PaginatedUnmatchedPlumeOutlineList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedUnmatchedPlumeOutlineListFromJSON(json: any): PaginatedUnmatchedPlumeOutlineList {
    return PaginatedUnmatchedPlumeOutlineListFromJSONTyped(json, false);
}

export function PaginatedUnmatchedPlumeOutlineListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUnmatchedPlumeOutlineList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(UnmatchedPlumeOutlineFromJSON)),
    };
}

export function PaginatedUnmatchedPlumeOutlineListToJSON(json: any): PaginatedUnmatchedPlumeOutlineList {
    return PaginatedUnmatchedPlumeOutlineListToJSONTyped(json, false);
}

export function PaginatedUnmatchedPlumeOutlineListToJSONTyped(value?: PaginatedUnmatchedPlumeOutlineList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(UnmatchedPlumeOutlineToJSON)),
    };
}

